export default {
  CAMPAIGN: 'campaign',
  SUBSCRIPTION: 'subscription',
}
